(function () {
	'use strict';

	angular.module('smb-app')
		.directive('smbStatus',[StatusDirective])
		.controller('StatusController', [
			StatusController
		]);

	var templateUrl = require('./status.template');
	function StatusDirective() {
		return {
			restrict: 'E',
			controller: StatusController,
			controllerAs: 'vm',
			templateUrl: templateUrl,
			bindToController: true,
			scope: {
				contentStatuses: '=',
				todoStatuses: '=',
				status: '=',
				onStatusChange: '&'
			}
		};
	}

	function StatusController() {
		var vm = this;
		vm.onStatusSelected = onStatusSelected;

		function onStatusSelected() {
			vm.onStatusChange();
		}
	}
}());


//////////////////
// WEBPACK FOOTER
// ./app/components/status/status.js
// module id = 95
// module chunks = 1